module.exports = __webpack_public_path__ + "static/media/tertiary-1.5d2e25da.png";